import { useCallback, useEffect, useState } from 'react';
import { createDate, differenceInHours } from '@lingoda/dates';
import { userSelector } from '@lingoda/auth';
import { useSelector } from '@lingoda/hooks';
import { studentM2MCheckoutPath, useRouteMatch } from '@lingoda/router';
import { getDismissForTimezone } from '../utils';

export const useShouldShowTimezoneDifferenceBar = () => {
    const [isTimezoneBarDismissed, setTimezoneBarDismissed] = useState(true);
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const user = useSelector(userSelector);
    const isNotSprinter = !!user && !user.isSprintRunner;
    const isNotM2MCheckout = !useRouteMatch(studentM2MCheckoutPath.raw);

    const dismiss = useCallback(() => setTimezoneBarDismissed(true), []);

    useEffect(() => {
        const localDate = new Date();
        const appDate = createDate();
        const diff = differenceInHours(localDate, appDate);

        const shouldBeShown =
            isNotSprinter &&
            isNotM2MCheckout &&
            diff !== 0 &&
            localTimezone !== getDismissForTimezone();
        setTimezoneBarDismissed(!shouldBeShown);
    }, [localTimezone, user?.timezone, isNotSprinter, isNotM2MCheckout]);

    return {
        isShown: !isTimezoneBarDismissed,
        dismiss,
        localTimezone,
    };
};
